import React, { useContext, useEffect, useState } from 'react';
import './../../../form.css'
import { Field } from 'formik'
import { TextField } from 'formik-material-ui'

import {
    Grid,
    Card,
    CardContent,
    CardHeader,
    Divider
} from '@material-ui/core';

import { 
    Select, 
    InputFiles,
    FileList
} from '../../../../common'

import { 
    FieldError 
} from '../../../../common'

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';

import { SapTableNames, LocalTableNames } from '../../../../../helpers';

import { makeStyles } from '@material-ui/core/styles';
import { decimalNumberField } from '../../../../../helpers/Utils';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
}));

export const CreditRiskForm = (props) => {
    const classes = useStyles();

    const {        
        state,
        getTableOptions,
        getTableOptionsWithCode
    } = useContext(CustomerRequestContext)

    const { 
        values,
        setFieldValue,
        isSavingRequest
    } = useContext(TabsContext);

    const fileUploadedHandler = (storedFile) => {
        const docs = [].concat(values.riskEvaluation.sheetInfoDocs || []);
        docs.push({ ...storedFile });
        // We need to set the value manually
        // otherwise setFieldValue will not work property
        values.riskEvaluation.sheetInfoDocs = docs;
        setFieldValue("riskEvaluation.sheetInfoDocs", docs);
    }

    const fileRemovedHandler = (storedFile) => {
        const docs = values.riskEvaluation.sheetInfoDocs.filter(x => x.storedFileId !== storedFile.storedFileId);
        // We need to set the value manually
        // otherwise setFieldValue will not work property
        values.riskEvaluation.sheetInfoDocs = docs;
        setFieldValue("riskEvaluation.sheetInfoDocs", docs);
    }

    return (
        <Card>
            <CardHeader title="Credit risk evaluation"/>
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xl={12} md={12} xs={12}>
                        <Select
                            name="order.paymentTermId"
                            label="Payment terms *"
                            disabled={props.disabled}
                            options={getTableOptionsWithCode(SapTableNames.PaymentTerms, values.dbType)}
                        />
                        <FieldError name="order.paymentTermId" errors={state.errors} />
                    </Grid>
                    <Grid item xl={6} md={12} xs={12}>
                        <Select
                            name="riskEvaluation.creditControlAreaId"
                            label="Credit control area *"
                            disabled={props.disabled}
                            options={getTableOptionsWithCode(SapTableNames.CreditControlAreas, values.dbType)}
                        />
                        <FieldError name="riskEvaluation.creditControlAreaId" errors={state.errors} />
                    </Grid>
                    <Grid item xl={6} md={12} xs={12}>
                        <Select
                            name="riskEvaluation.ratingId"
                            label="Rating"
                            disabled={props.disabled}
                            options={getTableOptions(LocalTableNames.Ratings, values.dbType)}
                        />
                        <FieldError name="riskEvaluation.ratingId" errors={state.errors} />
                    </Grid>  
                    <Grid item xl={6} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            name="riskEvaluation.creditLimit"
                            variant="outlined"
                            label="Credit limit *"
                            disabled={props.disabled}
                            component={decimalNumberField}
                        />
                        <FieldError name="riskEvaluation.creditLimit" errors={state.errors} />
                    </Grid>
                    <Grid item xl={6} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            name="riskEvaluation.globalCreditLimit"
                            variant="outlined"
                            label="Global credit limit *"
                            disabled={props.disabled}
                            component={decimalNumberField}
                        />
                        <FieldError name="riskEvaluation.globalCreditLimit" errors={state.errors} />
                    </Grid>
                    <Grid item xl={12} md={12} xs={12}>
                        <Select
                            name="riskEvaluation.creditLimitCurrencyId"
                            label="Currency *"
                            disabled={props.disabled}
                            options={getTableOptionsWithCode(SapTableNames.Currencies, values.dbType)}                            
                        />
                        <FieldError name="riskEvaluation.creditLimitCurrencyId" errors={state.errors} />
                    </Grid>
                    <Grid item xl={12} md={12} xs={12}>
                        <FileList 
                            title="Sheet information *"
                            files={values.riskEvaluation ? values.riskEvaluation.sheetInfoDocs : []}
                            disabled={props.disabled}
                            onFileRemoved={fileRemovedHandler}
                        />
                        <FieldError name="riskEvaluation.sheetInfoDocs" errors={state.errors} />
                    </Grid>
                    {!props.disabled &&
                        <Grid item xl={12} md={12} xs={12}>
                            <InputFiles 
                                title="Upload attachments"
                                onFileUploaded={fileUploadedHandler}/>
                        </Grid>
                    }
                </Grid>
            </CardContent>
        </Card>
    );
}